import { Box } from "@mui/material";
import image from '../../assets/img/manvar-logo.png';

export const LogoImage = () => {
  return (
    <Box
        component="img"
        sx={{
            height: 175,
            width: '100%',
            padding: 3,
            // backgroundColor: '#a36464ff'
        }}
        src={image}
    />
  )
}
